import { Controller as BaseController } from 'stimulus'

export class Controller extends BaseController {
  static targets = [
    'item',
    'selectAll'
  ]

  connect() {
    this.itemTargets.forEach((item) => {
      item.dataset.nameAttrBackup = item.getAttribute('name')

      if (this.isSelectAllChecked) {
        item.checked = true
        this.skipOnFormSubmission(item)
      }
    })
  }

  itemToggled() {
    if (this.isSelectAllChecked) {
      this.itemTargets.forEach((item) => {
        this.skipOnFormSubmission(item)
      })
    } else {
      this.itemTargets.forEach((item) => {
        this.includeOnFormSubmission(item)
      })
    }
  }

  skipOnFormSubmission(item) {
    item.removeAttribute('name')
  }

  includeOnFormSubmission(item) {
    item.setAttribute('name', item.dataset.nameAttrBackup)
  }

  get isSelectAllChecked() {
    return this.selectAllTarget.checked
  }
}
